import { createSelector } from '@ngrx/store';
import { isRoleOfType, RoleType } from '@iss/libs/permissions';

import { appContextFeature } from './app-context.feature';

import { AsyncStatus } from '@iss/wo-common/types';

export const selectShouldCheckOnlyOneCustomer = createSelector(
  appContextFeature.selectRole,
  (role) => isRoleOfType(role, RoleType.Customer),
);

export const selectShouldCheckOnlyOneSite = createSelector(
  appContextFeature.selectRole,
  (role) =>
    isRoleOfType(role, RoleType.Customer),
);

export const selectShouldCheckOnlyOneServiceLocation = createSelector(
  appContextFeature.selectRole,
  (role) =>
    isRoleOfType(role, RoleType.Customer),
);

export const selectShouldResetCountries = createSelector(
  appContextFeature.selectRole,
  appContextFeature.selectCountries,
  (role, countries): boolean =>
    !role && countries.status !== AsyncStatus.INITIAL,
);
